import { render, staticRenderFns } from "./abreviaturas.vue?vue&type=template&id=6fbe7716&"
import script from "./abreviaturas.vue?vue&type=script&lang=js&"
export * from "./abreviaturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports